/*
 * Minimizes the desktop menu on scroll down
 *
 * @author BarrelNY
 *
 */

var NavMinimize = {
	init: function(){
		//What templates should NOT trigger this module?
		var excludedTemplates = [
			'body.views-page'
		].join();

		if ($(excludedTemplates).length) return;

		$header = $('.header');
		$headerTrans = $('.header-trans');
		this.threshold = 60;
		this.prevScrollY = 0;

		this.events();
	},
	scrollDirection: function(){
  		var scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
		var scrollDelta = (scrollTop > this.prevScrollY) ? -1 : 1
		this.prevScrollY = scrollTop;
		return scrollDelta;
	},
	events:function(){
		$(window).on('scroll', this.toggleOnScroll.bind(this));

		// Handle FullPage scrolling
		$('body').on('fullPage__onLeave', this.toggleOnFullPageScroll.bind(this));

		// Handle scrolling in .scroll div
		if ($('.U1-template').length) {
			$('.scroll').on('scroll', this.toggleOnDivScroll.bind(this));
		}
	},
	toggleOnScroll: function(e) {
		if ( this.scrollDirection() > 0 ) {
			this.maximize();
		} else
		if ( $(document).scrollTop() > this.threshold ) {
			this.minimize();
		} else {
			this.maximize();
		}
	},
	toggleOnFullPageScroll: function(e, index, nextIndex, direction) {
		$header = $('.header');
		$headerTrans = $('.header-trans');

		if (index == 3 && nextIndex == 4){
			this.minimize();
		} else if(index == 4 && nextIndex == 3){
			this.maximize();
		} else {
			return;
		}
	},
	toggleOnDivScroll: function() {
		if ( $('.scroll').scrollTop() > this.threshold ) {
			this.minimize();
		} else {
			this.maximize();
		}
	},
	minimize: function() {
		$header.addClass('minimize');
	},
	maximize: function() {
		$headerTrans.css('display', 'block');
		$header.removeClass('minimize');
	}
}

module.exports = NavMinimize;
